<template>
  <div class="spinner-parent">
    <div v-if="$route.name == 'Editors Picks'" class="col-12">
      <div class="card">
        <div class="card-header">
          <h1>Editor's Picks</h1>
        </div>
      </div>

      <div class="card">
        <div class="card-block spinner-parent">
          <spinner ref="spinner" size="md" text="Loading ..." />

          <div class="table-responsive">
            <table class="entities table table-bordered table-striped table-sm">
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in picks" :key="item.id" :data-id="item.id">
                  <td>{{ item.name }}</td>
                  <td class="table-list__cell--narrow">
                    <router-link
                      class="btn btn-primary btn-sm"
                      :to="item.url"
                    >
                      Edit
                    </router-link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <router-view />
      </div>
    </div>
  </div><!--/.row-->
</template>

<script>
export default {
  name: 'EditorsPicksList',

  data() {
    return {
      picks: [
        {
          id: 0,
          type: 'articles',
          name: 'Articles',
          url: '/admin/editors-picks/edit-articles',
        },
        {
          id: 1,
          type: 'faq',
          name: 'FAQ',
          url: '/admin/editors-picks/edit-faq',
        },
        {
          id: 2,
          type: 'media_doc',
          name: 'Documents',
          url: '/admin/editors-picks/edit-documents',
        },
      ],
    };
  },
};
</script>



// WEBPACK FOOTER //
// EditorsPicksList.vue?c1b17586